module.exports = __webpack_public_path__ + "static/media/nodata.c387716e.png";